import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enLocale from '@/locales/en.json';

// @ts-ignore
import enKitLocale from '@dtt/ui-kit/src/locale/lang/en.json';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en: { ...enLocale, ...enKitLocale },
  },
});

function setI18nLanguage() {
  const lang = 'en';
  i18n.locale = lang;
  document.title = enLocale.header.title;
  document.documentElement.lang = lang;

  localStorage.setItem('lang', lang);
  return lang;
}

setI18nLanguage();

export { i18n, setI18nLanguage };
